import { SortBy } from '../enums';

export const defaultColorSort: SortBy = SortBy.TrendingNow;
